import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import {
  StoreSettings,
  StoreGeneralSettings,
  ShippingSettings,
  PaymentSettings,
  NotificationSettings,
  DisplaySettings,
  OrderSettings,
  ProductSuggestionSettings,
  BostaSettings,
  ShippingRegion
} from '../types/storeSettings';
import { Banner } from '../components/store/StoreBanner';
import { Promotion } from '../components/store/ProductPromotion';
import { detectDefaultValues, autoFixData } from '../utils/dataProtection';

// قائمة المناطق والمدن المصرية الافتراضية الجاهزة للتسعير
export const DEFAULT_EGYPT_SHIPPING_REGIONS: ShippingRegion[] = [
  {
    id: 'cairo',
    name: 'القاهرة',
    isActive: true,
    cities: [{ id: 'cairo_city', name: 'القاهرة', shippingCost: 40, estimatedDeliveryDays: 2, isActive: true }]
  },
  {
    id: 'giza',
    name: 'الجيزة',
    isActive: true,
    cities: [{ id: 'giza_city', name: 'الجيزة', shippingCost: 40, estimatedDeliveryDays: 2, isActive: true }]
  },
  {
    id: 'alexandria',
    name: 'الإسكندرية',
    isActive: true,
    cities: [{ id: 'alexandria_city', name: 'الإسكندرية', shippingCost: 50, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'qalyubia',
    name: 'القليوبية',
    isActive: true,
    cities: [{ id: 'qalyubia_city', name: 'القليوبية', shippingCost: 45, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'dakahlia',
    name: 'الدقهلية',
    isActive: true,
    cities: [{ id: 'dakahlia_city', name: 'الدقهلية', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'sharqia',
    name: 'الشرقية',
    isActive: true,
    cities: [{ id: 'sharqia_city', name: 'الشرقية', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'gharbia',
    name: 'الغربية',
    isActive: true,
    cities: [{ id: 'gharbia_city', name: 'الغربية', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'monufia',
    name: 'المنوفية',
    isActive: true,
    cities: [{ id: 'monufia_city', name: 'المنوفية', shippingCost: 50, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'beheira',
    name: 'البحيرة',
    isActive: true,
    cities: [{ id: 'beheira_city', name: 'البحيرة', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'kafr_el_sheikh',
    name: 'كفر الشيخ',
    isActive: true,
    cities: [{ id: 'kafr_el_sheikh_city', name: 'كفر الشيخ', shippingCost: 60, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'damietta',
    name: 'دمياط',
    isActive: true,
    cities: [{ id: 'damietta_city', name: 'دمياط', shippingCost: 60, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'port_said',
    name: 'بورسعيد',
    isActive: true,
    cities: [{ id: 'port_said_city', name: 'بورسعيد', shippingCost: 60, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'ismailia',
    name: 'الإسماعيلية',
    isActive: true,
    cities: [{ id: 'ismailia_city', name: 'الإسماعيلية', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'suez',
    name: 'السويس',
    isActive: true,
    cities: [{ id: 'suez_city', name: 'السويس', shippingCost: 60, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'fayoum',
    name: 'الفيوم',
    isActive: true,
    cities: [{ id: 'fayoum_city', name: 'الفيوم', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'beni_suef',
    name: 'بني سويف',
    isActive: true,
    cities: [{ id: 'beni_suef_city', name: 'بني سويف', shippingCost: 55, estimatedDeliveryDays: 3, isActive: true }]
  },
  {
    id: 'minya',
    name: 'المنيا',
    isActive: true,
    cities: [{ id: 'minya_city', name: 'المنيا', shippingCost: 60, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'asyut',
    name: 'أسيوط',
    isActive: true,
    cities: [{ id: 'asyut_city', name: 'أسيوط', shippingCost: 65, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'sohag',
    name: 'سوهاج',
    isActive: true,
    cities: [{ id: 'sohag_city', name: 'سوهاج', shippingCost: 65, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'qena',
    name: 'قنا',
    isActive: true,
    cities: [{ id: 'qena_city', name: 'قنا', shippingCost: 70, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'luxor',
    name: 'الأقصر',
    isActive: true,
    cities: [{ id: 'luxor_city', name: 'الأقصر', shippingCost: 75, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'aswan',
    name: 'أسوان',
    isActive: true,
    cities: [{ id: 'aswan_city', name: 'أسوان', shippingCost: 75, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'red_sea',
    name: 'البحر الأحمر',
    isActive: true,
    cities: [{ id: 'red_sea_city', name: 'البحر الأحمر', shippingCost: 80, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'new_valley',
    name: 'الوادي الجديد',
    isActive: true,
    cities: [{ id: 'new_valley_city', name: 'الوادي الجديد', shippingCost: 85, estimatedDeliveryDays: 5, isActive: true }]
  },
  {
    id: 'matrouh',
    name: 'مطروح',
    isActive: true,
    cities: [{ id: 'matrouh_city', name: 'مطروح', shippingCost: 80, estimatedDeliveryDays: 4, isActive: true }]
  },
  {
    id: 'north_sinai',
    name: 'شمال سيناء',
    isActive: true,
    cities: [{ id: 'north_sinai_city', name: 'شمال سيناء', shippingCost: 85, estimatedDeliveryDays: 5, isActive: true }]
  },
  {
    id: 'south_sinai',
    name: 'جنوب سيناء',
    isActive: true,
    cities: [{ id: 'south_sinai_city', name: 'جنوب سيناء', shippingCost: 85, estimatedDeliveryDays: 5, isActive: true }]
  },
  {
    id: 'october',
    name: 'السادس من أكتوبر',
    isActive: true,
    cities: [{ id: 'october_city', name: 'السادس من أكتوبر', shippingCost: 40, estimatedDeliveryDays: 2, isActive: true }]
  }
];


// الإعدادات الافتراضية للمتجر
const defaultStoreSettings: StoreSettings = {
  general: {
    storeName: 'اليكترونيات السواح',
    storeDescription: 'متخصصون في بيع وصيانة جميع أنواع الأجهزة الإلكترونية والكهربائية بأفضل الأسعار وأعلى جودة.',
    storeEmail: 'info@alsawah-electronics.com',
    storePhone: '0123456789',
    storeAddress: 'العنوان، المدينة، البلد',
    storeLogo: '',
    storeFavicon: '',
    socialLinks: {
      facebook: 'https://facebook.com/alsawah-electronics',
      twitter: 'https://twitter.com/alsawah-electronics',
      instagram: 'https://instagram.com/alsawah-electronics',
      youtube: 'https://youtube.com/alsawah-electronics',
      whatsapp: 'https://wa.me/0123456789'
    },
    facebookIntegration: {
      pageId: '',
      accessToken: '',
      isEnabled: false,
      autoPostNewProducts: false
    },
    workingHours: {
      sunday: '9:00 صباحًا - 9:00 مساءً',
      monday: '9:00 صباحًا - 9:00 مساءً',
      tuesday: '9:00 صباحًا - 9:00 مساءً',
      wednesday: '9:00 صباحًا - 9:00 مساءً',
      thursday: '9:00 صباحًا - 9:00 مساءً',
      friday: '2:00 مساءً - 9:00 مساءً',
      saturday: '9:00 صباحًا - 9:00 مساءً'
    },
    isStoreEnabled: true
  },
  shipping: {
    enableShipping: true,
    shippingMethods: [
      {
        id: 'standard',
        name: 'الشحن العادي',
        description: 'توصيل خلال 3-5 أيام عمل',
        cost: 30,
        estimatedDeliveryDays: 5,
        isActive: true,
        icon: 'local_shipping',
        shippingType: 'fixed'
      },
      {
        id: 'express',
        name: 'الشحن السريع',
        description: 'توصيل خلال 1-2 يوم عمل',
        cost: 50,
        estimatedDeliveryDays: 2,
        isActive: true,
        icon: 'delivery_dining',
        shippingType: 'fixed'
      }
    ],
    defaultShippingMethod: 'standard',
    freeShippingThreshold: 500,
    shippingRegions: [
      {
        id: 'cairo',
        name: 'القاهرة',
        cities: [
          {
            id: 'cairo_city',
            name: 'القاهرة',
            shippingCost: 30,
            estimatedDeliveryDays: 2,
            isActive: true
          },
          {
            id: 'giza',
            name: 'الجيزة',
            shippingCost: 30,
            estimatedDeliveryDays: 2,
            isActive: true
          }
        ],
        isActive: true
      },
      {
        id: 'alexandria',
        name: 'الإسكندرية',
        cities: [
          {
            id: 'alexandria_city',
            name: 'الإسكندرية',
            shippingCost: 40,
            estimatedDeliveryDays: 3,
            isActive: true
          }
        ],
        isActive: true
      }
    ],
    enablePickup: true,
    pickupLocations: [
      {
        id: 'main_store',
        name: 'المتجر الرئيسي',
        address: ' bab allouq,cairo',
        city: 'القاهرة',
        phone: '01025654218',
        workingHours: '9 صباحاً - 9 مساءً',
        isActive: true
      }
    ]
  },
  payment: {
    enableCashOnDelivery: true,
    enableBankTransfer: true,
    enableElectronicPayment: false,
    bankAccounts: [
      {
        id: 'bank1',
        bankName: 'البنك الأهلي المصري',
        accountName: 'اسم الحساب',
        accountNumber: '1234567890',
        iban: 'EG123456789012345678901234',
        isActive: true
      }
    ],
    paymentGateways: [
      {
        id: 'fawry',
        name: 'فوري',
        isActive: false,
        logo: 'https://www.fawry.com/wp-content/uploads/2019/12/fawry-logo.png'
      },
      {
        id: 'vodafone_cash',
        name: 'فودافون كاش',
        isActive: false,
        logo: 'https://www.vodafone.com.eg/public/upload/images/1594112616_Vodafone%20Cash%20Logo.png'
      },
      {
        id: 'instapay',
        name: 'إنستاباي',
        isActive: false,
        logo: 'https://instapay.eg/wp-content/uploads/2022/01/instapay-logo.png'
      }
    ]
  },
  notification: {
    enableEmailNotifications: true,
    enableSmsNotifications: false,
    enablePushNotifications: false,
    notifyOnNewOrder: true,
    notifyOnOrderStatusChange: true,
    notifyOnLowStock: true,
    adminEmails: ['admin@store.com'],
    emailTemplates: {
      orderConfirmation: 'تم استلام طلبك رقم {{orderNumber}} بنجاح',
      orderShipped: 'تم شحن طلبك رقم {{orderNumber}}',
      orderDelivered: 'تم تسليم طلبك رقم {{orderNumber}}',
      orderCancelled: 'تم إلغاء طلبك رقم {{orderNumber}}'
    }
  },
  display: {
    theme: 'default',
    productsPerPage: 12,
    showOutOfStockProducts: true,
    showProductRatings: true,
    showRelatedProducts: true,
    enableWishlist: true,
    enableProductComparison: false,
    showBanners: true,
    showPromotions: true,
    primaryColor: '#0d51d6',
    secondaryColor: '#f50057',
    backgroundColor: '#ffffff',
    textColor: '#333333',
    buttonBg: '#0d51d6',
    buttonText: '#ffffff',
    buttonRadius: '8px',
    buttonStyle: 'solid',
    fontFamily: 'Cairo',
    productCardSize: 'medium',
    productCardColumns: 4,
    productCardStyle: 'classic',
    showQuickView: true,
    homepageSections: [
      { id: 'banners', label: 'البانرات الترويجية', enabled: true },
      { id: 'promotions', label: 'العروض الخاصة', enabled: true },
      { id: 'featured', label: 'المنتجات المميزة', enabled: true },
      { id: 'bestsellers', label: 'الأكثر مبيعاً', enabled: true },
      { id: 'latest', label: 'أحدث المنتجات', enabled: true }
    ],
    mobileBottomBarEnabled: true,
    mobileBottomBarShowLabels: true,
    mobileBottomBarStyle: 'classic',
    mobileBottomBarItems: [
      { id: 'home', label: 'الرئيسية', icon: 'home', link: '/', enabled: true },
      { id: 'categories', label: 'الأقسام', icon: 'category', link: '/categories', enabled: true },
      { id: 'cart', label: 'السلة', icon: 'shopping_cart', link: '/cart', enabled: true },
      { id: 'wishlist', label: 'المفضلة', icon: 'favorite', link: '/favorites', enabled: true },
      { id: 'profile', label: 'حسابي', icon: 'person', link: '/account', enabled: true }
    ],
    mobileProductColumns: 2,
    mobileMainMenuItems: [
      { id: 'home', title: 'الرئيسية', icon: 'home', path: '/', enabled: true, color: '#0d51d6' },
      { id: 'offers', title: 'العروض الخاصة', icon: 'local_offer', path: '/offers', enabled: true, color: '#f44336', badge: 'جديد' },
      { id: 'bestsellers', title: 'الأكثر مبيعاً', icon: 'trending_up', path: '/bestsellers', enabled: true, color: '#4caf50' },
      { id: 'featured', title: 'المنتجات المميزة', icon: 'star', path: '/featured', enabled: true, color: '#ff9800' }
    ],
    mobileBottomMenuItems: [
      { id: 'about', title: 'حول المتجر', icon: 'info', path: '/about', enabled: true },
      { id: 'contact', title: 'اتصل بنا', icon: 'phone', path: '/contact', enabled: true },
      { id: 'profile', title: 'حسابي', icon: 'person', path: '/profile', enabled: true }
    ],
    banners: [
      {
        id: '1',
        title: 'عروض حصرية على الأجهزة الإلكترونية',
        subtitle: 'خصومات تصل إلى 30% على جميع المنتجات',
        imageUrl: 'https://source.unsplash.com/random/1200x400/?electronics',
        buttonText: 'تسوق الآن',
        buttonLink: '/store/categories',
        backgroundColor: '#0d51d6',
        textColor: '#ffffff'
      },
      {
        id: '2',
        title: 'أحدث الهواتف الذكية',
        subtitle: 'اكتشف أحدث التقنيات بأفضل الأسعار',
        imageUrl: 'https://source.unsplash.com/random/1200x400/?smartphone',
        buttonText: 'اكتشف المزيد',
        buttonLink: '/product/smartphone',
        backgroundColor: '#673ab7',
        textColor: '#ffffff'
      }
    ],
    promotions: [
      {
        id: '1',
        title: 'أجهزة منزلية بخصم 20%',
        description: 'تسوق الآن واحصل على خصم حصري على جميع الأجهزة المنزلية',
        imageUrl: 'https://source.unsplash.com/random/600x300/?appliances',
        backgroundColor: '#f44336',
        textColor: '#ffffff',
        buttonText: 'تسوق الآن',
        buttonLink: '/store/categories',
        position: 'right',
        size: 'medium'
      }
    ]
  },
  order: {
    minimumOrderAmount: 0,
    maximumOrderItems: 100,
    allowGuestCheckout: true,
    requirePhoneNumber: true,
    autoConfirmOrders: false,
    orderNumberPrefix: 'ORD-',
    orderCancellationPeriod: 24,
    returnPeriod: 14,
    returnPolicy: 'يمكن إرجاع المنتجات خلال 14 يومًا من تاريخ الاستلام شرط أن تكون بحالتها الأصلية وغير مستخدمة.'
  },
  productSuggestion: {
    isEnabled: true,
    buttonText: 'أخبرنا إذا كان يباع بسعر أقل أو اقترح سعراً',
    destinationType: 'system',
    destinationValue: ''
  },
  bosta: {
    enabled: false,
    apiKey: '',
    defaultPickupCity: '',
    defaultPickupZone: '',
    defaultPickupDistrict: '',
    defaultPickupStreet: '',
    defaultPickupBuilding: '',
    defaultPickupPhone: '',
    deliveryType: '15',
    enableCOD: true
  },
  lastUpdated: new Date()
};

// دمج الإعدادات الافتراضية مع الإعدادات الموجودة
const mergeWithDefaults = (existingSettings: any): StoreSettings => {
  console.log('Merging existing settings with defaults...');
  console.log('Existing settings received:', existingSettings);

  // التحقق من وجود البيانات المخصصة وحمايتها
  const preserveCustomData = (defaultSection: any, existingSection: any) => {
    if (!existingSection) return defaultSection;

    // حماية البيانات المخصصة من الاستبدال
    const preserved = { ...defaultSection };

    // نسخ جميع القيم المخصصة
    Object.keys(existingSection).forEach(key => {
      if (existingSection[key] !== null && existingSection[key] !== undefined) {
        preserved[key] = existingSection[key];
      }
    });

    return preserved;
  };

  const merged = {
    general: preserveCustomData(defaultStoreSettings.general, existingSettings.general),
    shipping: preserveCustomData(defaultStoreSettings.shipping, existingSettings.shipping),
    payment: preserveCustomData(defaultStoreSettings.payment, existingSettings.payment),
    notification: preserveCustomData(defaultStoreSettings.notification, existingSettings.notification),
    display: preserveCustomData(defaultStoreSettings.display, existingSettings.display),
    order: preserveCustomData(defaultStoreSettings.order, existingSettings.order),
    productSuggestion: preserveCustomData(defaultStoreSettings.productSuggestion, existingSettings.productSuggestion),
    bosta: existingSettings.bosta || defaultStoreSettings.bosta,
    lastUpdated: existingSettings.lastUpdated || new Date()
  };

  console.log('Merged settings with preserved custom data:', {
    storeEmail: merged.general.storeEmail,
    storePhone: merged.general.storePhone,
    workingHours: merged.general.workingHours,
    socialLinks: merged.general.socialLinks
  });

  return merged;
};

// الحصول على إعدادات المتجر
export const getStoreSettings = async (): Promise<StoreSettings> => {
  try {
    console.log('Fetching store settings from Firestore...');
    const settingsDoc = await getDoc(doc(db, 'settings', 'store'));

    if (settingsDoc.exists()) {
      console.log('Store settings document exists in Firestore');
      const data = settingsDoc.data();
      console.log('Raw data from Firestore:', data);

      // التحقق من وجود البيانات الأساسية
      if (!data.general || !data.general.storeEmail || !data.general.storePhone) {
        console.warn('Settings missing essential data, will merge with defaults');
      }

      // دمج البيانات الموجودة مع الافتراضية بدلاً من الاستبدال
      const mergedSettings = mergeWithDefaults(data);

      // تحويل تاريخ التحديث إلى كائن Date
      const lastUpdated = data.lastUpdated instanceof Date
        ? data.lastUpdated
        : data.lastUpdated?.toDate ? data.lastUpdated.toDate() : new Date();

      return {
        ...mergedSettings,
        lastUpdated
      };
    } else {
      console.log('Store settings document does not exist, creating with default settings');
      return await initializeStoreSettings();
    }
  } catch (error) {
    console.error('Error getting store settings:', error);


    // في حالة فشل كل شيء، حاول تهيئة الإعدادات
    try {
      return await initializeStoreSettings();
    } catch (initError) {
      console.error('Error initializing store settings:', initError);
      return defaultStoreSettings;
    }
  }
};

// تحديث إعدادات المتجر العامة
export const updateGeneralSettings = async (settings: StoreGeneralSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      general: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating general settings:', error);
    throw error;
  }
};

// تحديث إعدادات الشحن
export const updateShippingSettings = async (settings: ShippingSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      shipping: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating shipping settings:', error);
    throw error;
  }
};

// تحديث إعدادات الدفع
export const updatePaymentSettings = async (settings: PaymentSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      payment: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating payment settings:', error);
    throw error;
  }
};

// تحديث إعدادات الإشعارات
export const updateNotificationSettings = async (settings: NotificationSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      notification: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating notification settings:', error);
    throw error;
  }
};

// تحديث إعدادات العرض
export const updateDisplaySettings = async (settings: DisplaySettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      display: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating display settings:', error);
    throw error;
  }
};

// تحديث إعدادات الطلبات
export const updateOrderSettings = async (settings: OrderSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      order: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating order settings:', error);
    throw error;
  }
};

// تحديث إعدادات اقتراحات المنتجات
export const updateProductSuggestionSettings = async (settings: ProductSuggestionSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      productSuggestion: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating product suggestion settings:', error);
    throw error;
  }
};

export const updateBostaSettings = async (settings: BostaSettings): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      bosta: settings,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating Bosta settings:', error);
    throw error;
  }
};

// تحديث البانرات
export const updateBanners = async (banners: Banner[]): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      'display.banners': banners,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating banners:', error);
    throw error;
  }
};

// تحديث الإعلانات الترويجية
export const updatePromotions = async (promotions: Promotion[]): Promise<void> => {
  try {
    await updateDoc(doc(db, 'settings', 'store'), {
      'display.promotions': promotions,
      lastUpdated: new Date()
    });
  } catch (error) {
    console.error('Error updating promotions:', error);
    throw error;
  }
};

// تحديث إعدادات المتجر كاملة
export const updateStoreSettings = async (settings: StoreSettings): Promise<void> => {
  try {
    console.log('Updating store settings with:', settings);

    // التأكد من أن الإعدادات تحتوي على جميع الحقول المطلوبة
    if (!settings.general || !settings.shipping || !settings.payment ||
        !settings.notification || !settings.display || !settings.order || !settings.productSuggestion) {
      console.error('Settings object is incomplete:', settings);
      throw new Error('الإعدادات غير مكتملة');
    }

    // حفظ الإعدادات مباشرة
    const settingsToSave = {
      general: settings.general,
      shipping: settings.shipping,
      payment: settings.payment,
      notification: settings.notification,
      display: settings.display,
      order: settings.order,
      productSuggestion: settings.productSuggestion,
      bosta: settings.bosta || {},
      lastUpdated: new Date(),
      dataVersion: '1.0',
      lastModified: new Date()
    };

    console.log('Final settings to save (with preservation):', settingsToSave);

    // حفظ الإعدادات في Firestore
    await setDoc(doc(db, 'settings', 'store'), settingsToSave);

    // التحقق من أن الإعدادات تم حفظها بنجاح
    const verifyDoc = await getDoc(doc(db, 'settings', 'store'));
    if (verifyDoc.exists()) {
      const savedData = verifyDoc.data();
      console.log('Store settings updated and verified successfully');
      console.log('Saved data verification:', {
        hasGeneral: !!savedData?.general,
        hasShipping: !!savedData?.shipping,
        hasPayment: !!savedData?.payment,
        storeEmail: savedData?.general?.storeEmail,
        storePhone: savedData?.general?.storePhone,
        workingHours: savedData?.general?.workingHours,
        dataVersion: savedData?.dataVersion,
        lastModified: savedData?.lastModified
      });
    } else {
      console.error('Store settings were not saved properly');
      throw new Error('فشل حفظ الإعدادات');
    }
  } catch (error) {
    console.error('Error updating store settings:', error);
    throw error;
  }
};

// تهيئة إعدادات المتجر بالقيم الافتراضية
export const initializeStoreSettings = async (): Promise<StoreSettings> => {
  try {
    console.log('Initializing store settings with FORCED new values');

    // إنشاء إعدادات جديدة تماماً بدلاً من استخدام الإعدادات الافتراضية
    const newSettings: StoreSettings = {
      general: {
        storeName: 'المتجر الإلكتروني',
        storeDescription: 'متجر إلكتروني متخصص في بيع وصيانة الأجهزة الإلكترونية والكهربائية',
        storeEmail: 'info@store.com',
        storePhone: '0123456789',
        storeAddress: 'العنوان، المدينة، البلد',
        storeLogo: '',
        storeFavicon: '',
        socialLinks: {
          facebook: 'https://facebook.com/store',
          twitter: 'https://twitter.com/store',
          instagram: 'https://instagram.com/store',
          youtube: 'https://youtube.com/store',
          whatsapp: 'https://wa.me/0123456789'
        },
        workingHours: {
          sunday: '9:00 صباحًا - 9:00 مساءً',
          monday: '9:00 صباحًا - 9:00 مساءً',
          tuesday: '9:00 صباحًا - 9:00 مساءً',
          wednesday: '9:00 صباحًا - 9:00 مساءً',
          thursday: '9:00 صباحًا - 9:00 مساءً',
          friday: '2:00 مساءً - 9:00 مساءً',
          saturday: '9:00 صباحًا - 9:00 مساءً'
        },
        isStoreEnabled: true
      },
      shipping: {
        enableShipping: true,
        shippingMethods: [
          {
            id: 'aramex',
            name: 'أرامكس',
            description: 'توصيل خلال 2-3 أيام عمل',
            cost: 50,
            estimatedDeliveryDays: 3,
            isActive: true,
            icon: 'local_shipping',
            shippingType: 'fixed',
            regions: JSON.parse(JSON.stringify(DEFAULT_EGYPT_SHIPPING_REGIONS))
          },
          {
            id: 'fedex',
            name: 'فيديكس',
            description: 'توصيل خلال 1-2 يوم عمل',
            cost: 70,
            estimatedDeliveryDays: 2,
            isActive: true,
            icon: 'delivery_dining',
            shippingType: 'fixed',
            regions: JSON.parse(JSON.stringify(DEFAULT_EGYPT_SHIPPING_REGIONS))
          }
        ],
        defaultShippingMethod: 'aramex',
        freeShippingThreshold: 500,
        shippingRegions: DEFAULT_EGYPT_SHIPPING_REGIONS,
        enablePickup: true,
        pickupLocations: [
          {
            id: 'main_store',
            name: 'المتجر الرئيسي',
            address: ' bab allouq,cairo',
            city: 'القاهرة',
            phone: '01025654218',
            workingHours: '9 صباحاً - 9 مساءً',
            isActive: true
          }
        ]
      },
      payment: {
        enableCashOnDelivery: true,
        enableBankTransfer: true,
        enableElectronicPayment: false,
        bankAccounts: [
          {
            id: 'bank1',
            bankName: 'البنك الأهلي المصري',
            accountName: 'اسم الحساب',
            accountNumber: '1234567890',
            iban: 'EG123456789012345678901234',
            isActive: true
          }
        ],
        paymentGateways: [
          {
            id: 'fawry',
            name: 'فوري',
            isActive: false,
            logo: 'https://www.fawry.com/wp-content/uploads/2019/12/fawry-logo.png'
          },
          {
            id: 'vodafone_cash',
            name: 'فودافون كاش',
            isActive: false,
            logo: 'https://www.vodafone.com.eg/public/upload/images/1594112616_Vodafone%20Cash%20Logo.png'
          },
          {
            id: 'instapay',
            name: 'إنستاباي',
            isActive: false,
            logo: 'https://instapay.eg/wp-content/uploads/2022/01/instapay-logo.png'
          }
        ]
      },
      notification: {
        enableEmailNotifications: true,
        enableSmsNotifications: false,
        enablePushNotifications: false,
        notifyOnNewOrder: true,
        notifyOnOrderStatusChange: true,
        notifyOnLowStock: true,
        adminEmails: ['admin@store.com'],
        emailTemplates: {
          orderConfirmation: 'تم استلام طلبك رقم {{orderNumber}} بنجاح',
          orderShipped: 'تم شحن طلبك رقم {{orderNumber}}',
          orderDelivered: 'تم تسليم طلبك رقم {{orderNumber}}',
          orderCancelled: 'تم إلغاء طلبك رقم {{orderNumber}}'
        }
      },
      display: {
        theme: 'default',
        productsPerPage: 12,
        showOutOfStockProducts: true,
        showProductRatings: true,
        showRelatedProducts: true,
        enableWishlist: true,
        enableProductComparison: false,
        showBanners: true,
        showPromotions: true,
        primaryColor: '#0d51d6',
        secondaryColor: '#f50057',
        backgroundColor: '#ffffff',
        textColor: '#333333',
        buttonBg: '#0d51d6',
        buttonText: '#ffffff',
        buttonRadius: '8px',
        buttonStyle: 'solid',
        fontFamily: 'Cairo',
        productCardSize: 'medium',
        productCardColumns: 4,
        productCardStyle: 'classic',
        showQuickView: true,
        homepageSections: [
          { id: 'banners', label: 'البانرات الترويجية', enabled: true },
          { id: 'promotions', label: 'العروض الخاصة', enabled: true },
          { id: 'featured', label: 'المنتجات المميزة', enabled: true },
          { id: 'bestsellers', label: 'الأكثر مبيعاً', enabled: true },
          { id: 'latest', label: 'أحدث المنتجات', enabled: true }
        ],
        mobileBottomBarEnabled: true,
        mobileBottomBarShowLabels: true,
        mobileBottomBarStyle: 'classic',
        mobileBottomBarItems: [
          { id: 'home', label: 'الرئيسية', icon: 'home', link: '/', enabled: true },
          { id: 'categories', label: 'الأقسام', icon: 'category', link: '/categories', enabled: true },
          { id: 'cart', label: 'السلة', icon: 'shopping_cart', link: '/cart', enabled: true },
          { id: 'wishlist', label: 'المفضلة', icon: 'favorite', link: '/favorites', enabled: true },
          { id: 'profile', label: 'حسابي', icon: 'person', link: '/account', enabled: true }
        ],
        mobileProductColumns: 2,
        banners: [
          {
            id: '1',
            title: 'عروض حصرية على الأجهزة الإلكترونية',
            subtitle: 'خصومات تصل إلى 30% على جميع المنتجات',
            imageUrl: 'https://source.unsplash.com/random/1200x400/?electronics',
            buttonText: 'تسوق الآن',
            buttonLink: '/store/categories',
            backgroundColor: '#0d51d6',
            textColor: '#ffffff'
          }
        ],
        promotions: [
          {
            id: '1',
            title: 'أجهزة منزلية بخصم 20%',
            description: 'تسوق الآن واحصل على خصم حصري على جميع الأجهزة المنزلية',
            imageUrl: 'https://source.unsplash.com/random/600x300/?appliances',
            backgroundColor: '#f44336',
            textColor: '#ffffff',
            buttonText: 'تسوق الآن',
            buttonLink: '/store/categories',
            position: 'right',
            size: 'medium'
          }
        ]
      },
      order: {
        minimumOrderAmount: 100,
        maximumOrderItems: 20,
        allowGuestCheckout: true,
        requirePhoneNumber: true,
        autoConfirmOrders: true,
        orderNumberPrefix: 'ORD-',
        orderCancellationPeriod: 24,
        returnPeriod: 14,
        returnPolicy: 'يمكن إرجاع المنتجات خلال 14 يومًا من تاريخ الاستلام شرط أن تكون بحالتها الأصلية وغير مستخدمة.'
      },
      productSuggestion: {
        isEnabled: true,
        buttonText: 'أخبرنا إذا كان يباع بسعر أقل أو اقترح سعراً',
        destinationType: 'system',
        destinationValue: ''
      },
      lastUpdated: new Date()
    };

    // طباعة الإعدادات التي سيتم حفظها
    console.log('New settings to save:', newSettings);
    console.log('New shipping methods:', newSettings.shipping.shippingMethods);
    console.log('New shipping regions:', newSettings.shipping.shippingRegions);

    // حذف الإعدادات الحالية وإنشاء إعدادات جديدة
    await setDoc(doc(db, 'settings', 'store'), newSettings, { merge: false });

    // التحقق من أن الإعدادات تم حفظها بنجاح
    const verifyDoc = await getDoc(doc(db, 'settings', 'store'));
    if (verifyDoc.exists()) {
      console.log('Store settings initialized and verified successfully');
      const data = verifyDoc.data();
      console.log('Verified shipping settings:', data.shipping);

      // التحقق من وجود طرق الشحن ومناطق الشحن
      if (!data.shipping || !data.shipping.shippingMethods || data.shipping.shippingMethods.length === 0) {
        console.error('Shipping methods are still missing after initialization!');
      }

      if (!data.shipping || !data.shipping.shippingRegions || data.shipping.shippingRegions.length === 0) {
        console.error('Shipping regions are still missing after initialization!');
      }
    } else {
      console.error('Store settings were not saved properly');
    }

    return newSettings;
  } catch (error) {
    console.error('Error initializing store settings:', error);
    throw error;
  }
};
